// =====================================================================
// PropertyDetailFyCards.jsx — FY summary cards + FY tab selector.
// Extracted from PropertyDetail.jsx (iter-35e split).
// =====================================================================

const GRID_COLS = { 1: "md:grid-cols-1", 2: "md:grid-cols-2", 3: "md:grid-cols-3", 4: "md:grid-cols-4" };

export default function PropertyDetailFyCards({ summary, fys, activeFY, setActiveFY, fyColors }) {
  const cols = GRID_COLS[Math.min(summary.length, 4)] || "md:grid-cols-4";
  return (
    <>
      {/* FY summary cards */}
      <div className={`grid grid-cols-2 gap-4 mb-4 ${cols}`} data-testid="fy-summary">
        {summary.map((f) => (
          <button
            key={f.fy}
            onClick={() => setActiveFY(f.fy)}
            data-testid={`fy-card-${f.fy.replace(/\s/g, "")}`}
            className={`bg-white border-2 p-5 text-left transition-all hover:-translate-y-0.5 hover:shadow-md ${
              activeFY === f.fy ? "border-brand-ink" : "border-brand-line"
            }`}
          >
            <div className="flex items-center justify-between mb-2">
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em]" style={{ color: fyColors[f.fy] || "#71717A" }}>{f.fy}</div>
              <span className="w-2 h-2" style={{ background: fyColors[f.fy] }}></span>
            </div>
            <div className="font-display font-black text-2xl text-brand-ink">₹{f.total_revenue_lakhs}L</div>
            <div className="font-mono-tech text-[10px] text-zinc-500 mt-1">{f.months}mo · {f.avg_occupancy_pct}% occ · ₹{f.avg_adr} ADR</div>
          </button>
        ))}
      </div>

      {/* FY tabs */}
      <div className="flex gap-2 mb-4" data-testid="fy-tabs">
        {fys.map((fy) => (
          <button
            key={fy}
            onClick={() => setActiveFY(fy)}
            data-testid={`fy-tab-${fy.replace(/\s/g, "")}`}
            className={`font-display font-bold text-sm tracking-tight px-4 py-2 border-2 transition-colors ${
              activeFY === fy
                ? "bg-brand-ink text-brand-yellow border-brand-ink"
                : "bg-white text-brand-ink border-brand-line hover:border-brand-ink"
            }`}
          >
            {fy}
          </button>
        ))}
      </div>
    </>
  );
}
